export default __webpack_public_path__ + "static/media/mh-3.7bbd4204.png";